/*=========================================================================================
  File Name: moduleChatGetters.js
  Description: Chat Module Getters

==========================================================================================*/

// import contacts from '@/views/apps/chat/contacts'

export default {
  activeChatUser: state => state.activeChatUser,
  chatDataOfUser: state => id => {
    return state.chats[Object.keys(state.chats).find(key => key === id)]
  },
  whitelistContacts: (state, getters) => {
    const whitelistContacts = state.whitelistContacts.filter(() => true)
    return whitelistContacts.sort((x, y) => {
      const timeX = getters.chatLastMessaged(x.id).created_at
      const timeY = getters.chatLastMessaged(y.id).created_at
      return new Date(timeY) - new Date(timeX)
    })
  },
  blacklistContacts: (state, getters) => {
    const blacklistContacts = state.blacklistContacts.filter(() => true)

    return blacklistContacts.sort((x, y) => {
      const timeX = getters.chatLastMessaged(x.id).created_at
      const timeY = getters.chatLastMessaged(y.id).created_at
      return new Date(timeY) - new Date(timeX)
    })
  },
  contacts: state => [...state.whitelistContacts, ...state.blacklistContacts],
  contact: (state, getters) => contactId => getters.contacts.find(contact => contact.userId === contactId),
  chats: state => state.chats,
  chatUser: (state, getters, rootState) => id =>
    getters.contacts.find(contact => contact.userId === id) || rootState.AppActiveUser,

  chatLastMessaged: (state, getters) => id => {
    if (getters.chatDataOfUser(id)) return getters.chatDataOfUser(id).slice(-1)[0]
    else return false
  },
  chatUnseenMessages: (state, getters) => id => {
    let unseenMsg = 0
    const chatData = getters.chatDataOfUser(id)
    if (chatData) {
      chatData.map(chat => {
        if (!chat.isSeen && !chat.isSent) unseenMsg++
      })
    }
    return unseenMsg
  },
  countUnseenMessages: (state, getters) => {
    let unseenMsg = 0
    // eslint-disable-next-line no-unused-vars
    for (const [key, value] of Object.entries(getters.chats)) {
      if (value) {
        value.map(chat => {
          if (!chat.isSeen && !chat.isSent) unseenMsg++
        })
      }
    }
    return unseenMsg
  }
}
